// components/AlertDialog.jsx
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideAlert } from '../store/slices/uiSlice';

const AlertDialog = () => {
  const dispatch = useDispatch();
  const { show, message, severity } = useSelector((s) => s.ui.alertDialog);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
      <div className="w-full max-w-sm rounded-2xl bg-white p-5 shadow-2xl">
        <div className="mb-3 flex items-center gap-2">
          {/* simple warning dot */}
          <span className={`inline-block h-3 w-3 rounded-full ${
            severity === 'warning' ? 'bg-yellow-500' : 'bg-blue-500'
          }`} />
          <h3 className="text-lg font-semibold text-gray-900">
            {severity === 'warning' ? 'Warning' : 'Notice'}
          </h3>
        </div>

        <p className="text-gray-700 mb-6">{message}</p>

        <div className="flex justify-end">
          <button
            onClick={() => dispatch(hideAlert())}
            className="px-4 py-2 rounded-lg bg-yellow-500 text-white hover:bg-yellow-600 focus:outline-none"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertDialog;
